export default {
  computed: {
    provincesOptions() {
      return this.provinces
        .map((p) => ({
          label: p.name,
          value: p.id,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    },
    citiesOptions() {
      return this.cities
        .map((p) => ({
          id: p.id,
          value: p.name,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    },
  },
  mounted() {
    this.$services
      .resource('provinces')
      .get()
      .then((res) => {
        this.provinces = res.data.data.provinces;
        this.presetData();
      });
  },
  data() {
    return {
      provinces: [],
      cities: [],
      formName: 'formData',
      searchError: '',
      defaultCity: null,
      defaultProvince: null,
    };
  },
  methods: {
    selectCity(item) {
      this[this.formName].city = item.id;
    },

    async querySearchAsync(queryString, cb) {
      this.searchError = '';
      if (!queryString || queryString.length < 3) {
        this.searchError = 'Debe ingresar al menos 3 caracteres.';
        return cb([]);
      }

      await this.fetchCities(queryString);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(this.citiesOptions);
      }, 500);
    },

    fetchCities(query) {
      const params = {
        'filter[province]': this[this.formName].province,
        'filter[search]': query,
      };

      return this.$services
        .resource('cities')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => {
          this.cities = data.cities;
          if (this.cities.length === 0) {
            this.searchError = 'No se han encontrado resultados';
          }
        });
    },

    clearCity() {
      this[this.formName].cityName = null;
      this[this.formName].city = null;
    },

    presetData() {
      if (this.defaultProvince) {
        this[this.formName].province = this.defaultProvince;
      }
      if (this.defaultCity) {
        this[this.formName].city = this.defaultCity;
        this[this.formName].cityName = this.defaultCityName;
      }
    },
  },
};
